import { render, staticRenderFns } from "./FiltersModal.vue?vue&type=template&id=083dd0b4&scoped=true&lang=pug&"
import script from "./FiltersModal.vue?vue&type=script&lang=js&"
export * from "./FiltersModal.vue?vue&type=script&lang=js&"
import style0 from "./FiltersModal.vue?vue&type=style&index=0&id=083dd0b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083dd0b4",
  null
  
)

export default component.exports